module.exports = __webpack_public_path__ + "static/media/investpic2.743a3549.png";